var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.575 11.8638L7.5 11.9401L7.4175 11.8638C3.855 8.57548 1.5 6.40109 1.5 4.19619C1.5 2.6703 2.625 1.52589 4.125 1.52589C5.28 1.52589 6.405 2.28883 6.8025 3.32643H8.1975C8.595 2.28883 9.72 1.52589 10.875 1.52589C12.375 1.52589 13.5 2.6703 13.5 4.19619C13.5 6.40109 11.145 8.57548 7.575 11.8638ZM10.875 0C9.57 0 8.3175 0.617984 7.5 1.58692C6.6825 0.617984 5.43 0 4.125 0C1.815 0 0 1.83869 0 4.19619C0 7.07248 2.55 9.42997 6.4125 12.9929L7.5 14L8.5875 12.9929C12.45 9.42997 15 7.07248 15 4.19619C15 1.83869 13.185 0 10.875 0Z",
    fill: "#202020",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIco);
export default __webpack_public_path__ + "static/media/fav--ico.85a51713ef7841518fa454afdef105a6.svg";
export { ForwardRef as ReactComponent };